import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "pb-30 px-10 md-down:px-4" }
const _hoisted_2 = { class: "__report-lesson__header pt-10 pb-10 flex flex-nowrap justify-between items-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("svg", {
  class: "mr-2",
  width: "28",
  height: "28",
  viewBox: "0 0 28 28",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M17.5 7L10.5 14L17.5 21",
    stroke: "#94A3B8",
    "stroke-width": "2",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })
], -1)
const _hoisted_4 = { class: "flex items-center justify-center" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { class: "flex flex-nowrap gap-8 items-stretch" }
const _hoisted_7 = { class: "w-1/2 p-4 shadow-sm rounded-xl bg-white" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm" }, "Tổng số học sinh", -1)
const _hoisted_9 = { class: "font-bold text-4xl text-neutral-700" }
const _hoisted_10 = { class: "w-1/2 p-4 shadow-sm rounded-xl bg-white" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm" }, " Giáo viên bán trú ", -1)
const _hoisted_12 = { class: "font-bold text-4xl text-neutral-700" }
const _hoisted_13 = { class: "w-1/2 p-4 shadow-sm rounded-xl bg-white" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "text-neutral-500 text-sm" }, "Ngày học", -1)
const _hoisted_15 = { class: "font-bold text-4xl text-neutral-700" }
const _hoisted_16 = { class: "mt-10" }
const _hoisted_17 = { class: "flex flex-col" }
const _hoisted_18 = { class: "-my-2 overflow-x-auto sm:-mx-6 lg:-mx-8" }
const _hoisted_19 = { class: "py-2 align-middle inline-block min-w-full sm:px-6 lg:px-8" }
const _hoisted_20 = { class: "shadow overflow-hidden sm:rounded-lg" }
const _hoisted_21 = { class: "min-w-full divide-y text-neutral-200" }
const _hoisted_22 = { class: "bg-neutral-100 h-16" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider w-16 whitespace-nowrap"
}, " STT ", -1)
const _hoisted_24 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}, " Tên hiển thị ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}, " TUỔI ", -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("th", {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}, " Ngày học ", -1)
const _hoisted_27 = {
  scope: "col",
  class: "px-6 py-3 text-left text-xs font-semibold text-neutral-600 uppercase tracking-wider whitespace-nowrap"
}
const _hoisted_28 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_29 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_30 = { class: "flex items-center mb-2" }
const _hoisted_31 = ["src"]
const _hoisted_32 = { class: "font-medium leading-none text-white text-xs" }
const _hoisted_33 = { class: "ml-4 text-orange-600 font-semibold" }
const _hoisted_34 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_35 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_36 = { class: "px-6 py-4 whitespace-nowrap text-sm text-neutral-700" }
const _hoisted_37 = { class: "flex items-center mb-2" }
const _hoisted_38 = ["src"]
const _hoisted_39 = { class: "font-medium leading-none text-white text-xs" }
const _hoisted_40 = { class: "ml-4 font-semibold text-blue-600" }
const _hoisted_41 = {
  key: 1,
  class: "fixed top-1/2 left-1/2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Loading = _resolveComponent("Loading")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        class: "__record__title text-neutral-500 font-semibold whitespace-nowrap flex flex-nowrap items-center text-4xl cursor-pointer",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.push('/daycare-class')))
      }, [
        _hoisted_3,
        _createTextVNode(" Lớp bán trú: " + _toDisplayString(_ctx.classDetail.name), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("button", {
          type: "button",
          class: "h-12 button-p btn--ghost text-center mr-3 px-6 whitespace-nowrap",
          onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.push(`/add-students/${_ctx.id}`)))
        }, " Thêm học sinh ")
      ])
    ]),
    (!_ctx.isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _hoisted_8,
              _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.total), 1)
            ]),
            _createElementVNode("div", _hoisted_10, [
              _hoisted_11,
              _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.totalTeacher), 1)
            ]),
            _createElementVNode("div", _hoisted_13, [
              _hoisted_14,
              _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.dayOfWeekDisplay), 1)
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createElementVNode("div", _hoisted_18, [
                _createElementVNode("div", _hoisted_19, [
                  _createElementVNode("div", _hoisted_20, [
                    _createElementVNode("table", _hoisted_21, [
                      _createElementVNode("thead", _hoisted_22, [
                        _createElementVNode("tr", null, [
                          _hoisted_23,
                          _hoisted_24,
                          _hoisted_25,
                          _hoisted_26,
                          _createElementVNode("th", _hoisted_27, _toDisplayString(_ctx.$filters.terminology('teacher_short_name')) + " phụ trách can thiệp ", 1)
                        ])
                      ]),
                      _createElementVNode("tbody", null, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.students, (student, index) => {
                          return (_openBlock(), _createElementBlock("tr", {
                            key: student.id,
                            class: _normalizeClass(
												index % 2 === 0
													? 'bg-white'
													: 'bg-neutral-50'
											)
                          }, [
                            _createElementVNode("td", _hoisted_28, _toDisplayString(index + 1), 1),
                            _createElementVNode("td", _hoisted_29, [
                              _createVNode(_component_router_link, {
                                to: `/record/student/${student?.id}`
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_30, [
                                    (
																student
																	?.profile_photo
																	?.w200
															)
                                      ? (_openBlock(), _createElementBlock("img", {
                                          key: 0,
                                          class: "shadow-sm inline-block h-6 w-6 rounded-full",
                                          src: 
																student
																	?.profile_photo
																	?.w200
															,
                                          alt: ""
                                        }, null, 8, _hoisted_31))
                                      : (_openBlock(), _createElementBlock("span", {
                                          key: 1,
                                          class: "inline-flex items-center justify-center h-6 w-6 rounded-full",
                                          style: _normalizeStyle({
																background:
																	student
																		?.profile_photo
																		?.default
																		?.color,
															})
                                        }, [
                                          _createElementVNode("span", _hoisted_32, _toDisplayString(student
																		?.profile_photo
																		?.default
																		?.initial), 1)
                                        ], 4)),
                                    _createElementVNode("div", _hoisted_33, _toDisplayString(student?.name), 1)
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["to"])
                            ]),
                            _createElementVNode("td", _hoisted_34, _toDisplayString(student.age), 1),
                            _createElementVNode("td", _hoisted_35, _toDisplayString(_ctx.getDays(student.id)), 1),
                            _createElementVNode("td", _hoisted_36, [
                              (student.main_staff)
                                ? (_openBlock(), _createBlock(_component_router_link, {
                                    key: 0,
                                    to: `/record/employee/${student?.main_staff?.id}`
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_37, [
                                        (
																student
																	.main_staff
																	?.profile_photo
																	?.w200
															)
                                          ? (_openBlock(), _createElementBlock("img", {
                                              key: 0,
                                              class: "shadow-sm inline-block h-6 w-6 rounded-full",
                                              src: 
																student
																	.main_staff
																	?.profile_photo
																	?.w200
															,
                                              alt: ""
                                            }, null, 8, _hoisted_38))
                                          : (_openBlock(), _createElementBlock("span", {
                                              key: 1,
                                              class: "inline-flex items-center justify-center h-6 w-6 rounded-full",
                                              style: _normalizeStyle({
																background:
																	student
																		.main_staff
																		?.profile_photo
																		?.default
																		?.color,
															})
                                            }, [
                                              _createElementVNode("span", _hoisted_39, _toDisplayString(student
																		.main_staff
																		?.profile_photo
																		?.default
																		?.initial), 1)
                                            ], 4)),
                                        _createElementVNode("div", _hoisted_40, _toDisplayString(student
																	.main_staff
																	?.name), 1)
                                      ])
                                    ]),
                                    _: 2
                                  }, 1032, ["to"]))
                                : _createCommentVNode("", true)
                            ])
                          ], 2))
                        }), 128))
                      ])
                    ])
                  ])
                ])
              ])
            ])
          ])
        ]))
      : (_openBlock(), _createElementBlock("div", _hoisted_41, [
          _createVNode(_component_Loading)
        ]))
  ]))
}